import { useState } from 'react';
import { Modal } from '../../Components/Modal/Modal';
import { Button } from '../../Components/Button/Button';
import { Exercise } from '../../Clients/reminds';
import styles from './AddExerciseTypeModal.module.css';

interface AddExerciseTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (exercise: Exercise) => void;
}

export const AddExerciseTypeModal: React.FC<AddExerciseTypeModalProps> = ({ isOpen, onClose, onAdd }) => {
  const [formData, setFormData] = useState<Partial<Exercise>>({
    name: '',
    notes: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.name) {
      onAdd(formData as Exercise);
      setFormData({ name: '', notes: '' });
      onClose();
    }
  };

  const handleCancel = () => {
    setFormData({ name: '', notes: '' });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCancel}>
      <h2 className={styles.title}>Add Exercise Type</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.field}>
          <label htmlFor="name" className={styles.label}>
            Name *
          </label>
          <input
            id="name"
            type="text"
            className={styles.input}
            value={formData.name || ''}
            onChange={e => setFormData({ ...formData, name: e.target.value })}
            placeholder="e.g., Running, Push-ups"
            required
          />
        </div>

        <div className={styles.field}>
          <label htmlFor="notes" className={styles.label}>
            Notes (optional)
          </label>
          <textarea
            id="notes"
            className={styles.textarea}
            value={formData.notes || ''}
            onChange={e => setFormData({ ...formData, notes: e.target.value })}
            placeholder="Additional notes..."
            rows={3}
          />
        </div>

        <div className={styles.actions}>
          <Button type="button" onClick={handleCancel} style={{ backgroundColor: 'var(--color-surface-primary)' }}>
            Cancel
          </Button>
          <Button type="submit">Add</Button>
        </div>
      </form>
    </Modal>
  );
};
